import { Button, Popover, TextField } from "@mui/material";
import { DateCalendar, DatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import React, { FC, useState } from "react";
import styled from "styled-components";

import { LocalizationProvider, RideStatusCell } from "@ryde/controls";
import { onActivateKeyDown, RideStatusEnum } from "@ryde/shared";

import { StyledPageWrapper } from "./controls.panels.styled";

const ContainerCols = styled.div`
  display: flex;
  gap: 10px;
`;

const StatusContainerStyled = styled.div`
  width: 200px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const PopoverContainerStyled = styled.div`
  width: 400px;
  margin-inline-start: 40px;
  /* display: flex; */
`;
const MonthContainerStyled = styled.div``;

export const RideControlsTestPanel: FC = () => {
  const enumValuesArray = Object.values(RideStatusEnum);
  const [openCalendar, setOpenCalendar] = useState(false);

  const handleOpenCalendar = (): void => {
    setOpenCalendar(!openCalendar);
  };

  const [value, setValue] = React.useState<Dayjs | null>(dayjs("2022-04-17"));
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const setDate = (val: dayjs.Dayjs | null): void => {
    setValue(val);
    setAnchorEl(null);
  };

  return (
    <StyledPageWrapper>
      <LocalizationProvider>
        <h1>Ride status cell controls</h1>
        <ContainerCols>
          <StatusContainerStyled>
            {enumValuesArray.map(x => (
              <RideStatusCell status={x} />
            ))}
          </StatusContainerStyled>
          <PopoverContainerStyled>
            <form>
              <TextField
                slotProps={{
                  htmlInput: {
                    autoComplete: "new-password",
                  },
                }}
              />

              <TextField
                slotProps={{
                  htmlInput: { inputMode: "numeric", pattern: "[0-9]*" },
                }}
              />
            </form>

            <DatePicker
              label={"Date"}
              // onChange={handleChange}
              // value={ Dayjs}
              format="DD/MM/YYYY"
            />

            <MonthContainerStyled>
              <span
                onClick={handleOpenCalendar}
                onKeyDown={onActivateKeyDown(handleOpenCalendar)}
                role="button"
                tabIndex={0}
              >
                19.07
              </span>
              <div className="calendarHolder">
                <DateCalendar />
              </div>
            </MonthContainerStyled>
          </PopoverContainerStyled>
          <PopoverContainerStyled>
            <div>
              <Button variant="outlined" onClick={handleClick}>
                Open Popover
              </Button>
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
              >
                <DateCalendar value={value} onChange={e => setDate(e)} />
              </Popover>
            </div>
          </PopoverContainerStyled>
        </ContainerCols>
      </LocalizationProvider>
    </StyledPageWrapper>
  );
};
